import { FC, useState } from 'react'
import styled from 'styled-components'
import { Card } from 'Components/Card/Card'
import { CountryFlagIcon } from 'Components/Icons/CountryFlagIcon'
import { StyledButton } from 'Components/Buttons/StyledButton'
import { useConfirmationModalContext } from 'Hooks/modals/useConfirmationModal'
import { useDeleteEmployerCountryQuery } from 'Hooks/api/JOONAdmin/useDeleteEmployerCountryQuery'
import { useEmployerInfoContext } from 'Contexts/EmployerInfoContext'
import { noPadding, spacingSM } from 'Utils/styles/spacing'
import {
  HeaderSection,
  ProgramName,
  ButtonSection
} from '../BenefitPrograms/JoonAdminProgramDetailsCard'
import { EmployerCountry, FeeSchedule } from 'Utils/types/employerInfo'
import { CountryCode, CountryNames } from 'Utils/types/countries'
import { CountryFeeSchedule } from './CountryFeeSchedule'
import { EditPricingDescriptionModal } from './EditPricingDescriptionModal'

const Header = styled(HeaderSection)`
  gap: ${spacingSM};
  cursor: pointer;
`

type JoonAdminCountryCardProps = {
  countryConfig: EmployerCountry
  onOpenFeeScheduleModal: (countryCode: CountryCode, feeSchedule: FeeSchedule | null) => void
}

export const JoonAdminCountryCard: FC<JoonAdminCountryCardProps> = ({
  countryConfig,
  onOpenFeeScheduleModal
}) => {
  const {
    state: { employerInfo }
  } = useEmployerInfoContext()

  const { countryCode } = countryConfig

  const { showModal } = useConfirmationModalContext()
  const { mutate } = useDeleteEmployerCountryQuery()
  const [showPricingModal, setShowPricingModal] = useState(false)

  const handleRemoveCountry = async () => {
    if (!employerInfo?.id) return

    const result = await showModal(
      `Remove Country: ${CountryNames[countryCode]}`,
      `Are you sure you want to remove this country from ${employerInfo?.name} (${countryConfig.employerId})?`
    )

    if (result) {
      mutate({ employerId: employerInfo.id, countryCode: countryCode })
    }
  }

  return (
    <>
      <Card style={{ minHeight: 220 }} padding={noPadding}>
        <Header onClick={() => setShowPricingModal(true)}>
          <ProgramName>{CountryNames[countryCode]}</ProgramName>
          <CountryFlagIcon countryCode={countryCode} />
        </Header>
        <CountryFeeSchedule
          countryConfig={countryConfig}
          onOpenFeeScheduleModal={onOpenFeeScheduleModal}
        />
        <ButtonSection>
          <StyledButton
            onClick={(e) => {
              e.stopPropagation()
              handleRemoveCountry()
            }}
            primary
            id="country.remove.button.label"
          />
        </ButtonSection>
      </Card>
      <EditPricingDescriptionModal
        showModal={showPricingModal}
        setShowModal={setShowPricingModal}
        countryConfig={countryConfig}
      />
    </>
  )
}
